import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { StatusState } from '../../../../shared/models/enum/statusState';
import { Historique } from './historique';
import { SupportDiffusion } from './support.diffusion';

export class Synthesis {


    public intitule: String;
    public forms: FormsEnum;
    public referenceAvis: String;
    public historique: Historique;
    public supportDiffusionList: Array<SupportDiffusion>;
    public status: StatusState;

    constructor() {

    }
}
